export interface Sentiment {
  type: string
  sentiment: string
  score: number
}

export interface SentimentProps {
  options: Option[]
  sentimentObj?: Sentiment | null
  readonly?: boolean
  handleEditSentiment?: any
}

export interface Option {
  value: string
  icon: string
  color: string
  hoverColor: string
}

export interface SentimentButtonProps {
  sentimentObj: Sentiment | null | undefined
  selectedOption: Option | null
  anchorEl: null | HTMLElement
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  readonly?: boolean
  isScoreVisible?: boolean
}

export const SentimentOptions: Option[] = [
  {
    value: 'negative',
    icon: '\uD83D\uDE21',
    color: '#FDECEA',
    hoverColor: '#C62828',
  },
  {
    value: 'mixed',
    icon: '\uD83D\uDE12',
    color: '#FFFDE7',
    hoverColor: '#BF360C',
  },
  {
    value: 'neutral',
    icon: '\uD83D\uDE10',
    color: '#FDF4E7',
    hoverColor: '#663D00',
  },
  {
    value: 'positive',
    icon: '\uD83D\uDE00',
    color: '#EFF7EE',
    hoverColor: '#1B5E20',
  },
]
